import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TypeOfVideoPipe } from '@features/video-player/pipes/type-of-video.pipe';
import { YoutubePlayerComponent } from '@features/video-player/youtube-player/youtube-player.component';
import { VimeoPlayerComponent } from '@features/video-player/vimeo-player/vimeo-player.component';

@Component({
    selector: 'app-video-player',
    imports: [TypeOfVideoPipe, YoutubePlayerComponent, VimeoPlayerComponent],
    templateUrl: './video-player.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoPlayerComponent {
    public readonly videoUrl = input.required<string>();
    public readonly muted = input<boolean>(true);
}
